import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { LegalEntityQueryKey } from './queryKey';
export var useUpdateLegalEntity = function () {
    var intl = useIntl();
    var queryClient = useQueryClient();
    var _a = useMutation(function (model) {
        return api.base
            .put("/api/legalentity/".concat(model.id), model)
            .then(function (res) { return res.data; });
    }, {
        onSuccess: function (result) {
            if (!result)
                return;
            queryClient.setQueryData([LegalEntityQueryKey.LegalEntities], function (old) {
                return old ? old.map(function (e) { return (e.id === result.id ? result : e); }) : old;
            });
        },
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading;
    return { updateLegalEntity: mutateAsync, isLoading: isLoading };
};
